import React from "react";
import { Exercise } from "../../libs/exercises/types";
import { DEFAULT_CONTAINER_COLOR } from "../ProgressionsTable/ColorPicker";

export const EXERCISE_DRAG_TYPE = "application/fitshape-exercise";

type Props = {
  exercise: Exercise;
  color?: string;
  onMoveToRoot?: () => void;
  onEdit: () => void;
  onDelete?: () => void;
  selectionMode?: boolean;
  selected?: boolean;
  onToggleSelect?: () => void;
};

export const ExerciseCard: React.FC<Props> = ({
  exercise,
  color = DEFAULT_CONTAINER_COLOR,
  onMoveToRoot,
  onEdit,
  onDelete,
  selectionMode,
  selected,
  onToggleSelect,
}) => {
  const handleDragStart = (e: React.DragEvent) => {
    e.dataTransfer.setData(
      EXERCISE_DRAG_TYPE,
      JSON.stringify({
        id: exercise.id,
        idContainer: exercise.idContainer ?? null,
      })
    );
    e.dataTransfer.effectAllowed = "move";
  };

  return (
    <div
      draggable={!selectionMode}
      onDragStart={selectionMode ? undefined : handleDragStart}
      onClick={selectionMode ? onToggleSelect : undefined}
      className={`relative bg-white dark:bg-gray-800 border-2 rounded-xl shadow-sm hover:shadow-md transition-all p-5 flex flex-col gap-2 ${
        selectionMode ? "cursor-pointer" : "cursor-grab active:cursor-grabbing"
      } ${selected ? "ring-2 ring-blue-500 border-blue-400" : ""}`}
      style={{ borderColor: selected ? undefined : `${color}30` }}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="flex items-center gap-3">
          {selectionMode && (
            <input
              type="checkbox"
              checked={!!selected}
              onChange={onToggleSelect}
              onClick={(e) => e.stopPropagation()}
              className="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500 flex-shrink-0"
            />
          )}
          <h3 className="font-semibold text-gray-900 dark:text-white text-sm">
            {exercise.name}
          </h3>
        </div>
        {!selectionMode && onMoveToRoot && (
          <button
            type="button"
            title="Sposta fuori dalla cartella"
            onClick={onMoveToRoot}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 p-1"
          >
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M10 3a1 1 0 01.707.293l4 4a1 1 0 01-1.414 1.414L11 6.414V16a1 1 0 11-2 0V6.414L6.707 8.707a1 1 0 01-1.414-1.414l4-4A1 1 0 0110 3z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        )}
      </div>
      {exercise.tags && exercise.tags.length > 0 && (
        <div className="flex flex-wrap gap-1">
          {exercise.tags.map((tag, i) => (
            <span
              key={i}
              className="inline-block px-2 py-0.5 text-xs font-medium rounded-full bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300"
            >
              {tag}
            </span>
          ))}
        </div>
      )}
      {!selectionMode && (
        <div className="mt-1 flex items-center gap-4">
          <button
            type="button"
            onClick={onEdit}
            className="text-sm font-medium text-blue-600 dark:text-blue-500 hover:underline text-left"
          >
            Modifica
          </button>
          {onDelete && (
            <button
              type="button"
              onClick={onDelete}
              className="text-sm font-medium text-red-600 dark:text-red-500 hover:underline text-left"
            >
              Elimina
            </button>
          )}
        </div>
      )}
    </div>
  );
};
